import styled from '@emotion/styled';
import CloseIcon from '@mui/icons-material/Close';
import { DialogContent, DialogTitle, IconButton } from '@mui/material';

import BootstrapDialog from '@/components/Dialog/BootstrapDialog';

import ApiKey from '@/pages/account-settings/components/ApiKey';
import theme from '@/theme';
import { atom, useRecoilState } from 'recoil';

const StyledDialogTitle = styled(DialogTitle)`
    padding: 0px !important;
`;

const StyledIconButton = styled(IconButton)`
    position: absolute;
    right: 1rem;
    color: ${theme.colors.primary};
    top: 0.5rem;
`;

const StyledDialogContent = styled(DialogContent)`
    padding: 0px !important;
`;

export const apiKeyModalIsOpen = atom({
    key: 'api-key-modal-is-open',
    default: false,
});

export default function () {
    const [isOpen, setIsOpen] = useRecoilState(apiKeyModalIsOpen);
    const onClose = () => setIsOpen(false);
    return (
        <BootstrapDialog onClose={onClose} open={isOpen}>
            <StyledDialogTitle id="delete-image-modal">
                <StyledIconButton aria-label="close" onClick={onClose}>
                    <CloseIcon />
                </StyledIconButton>
            </StyledDialogTitle>
            <StyledDialogContent>
                <ApiKey flex={1} />
            </StyledDialogContent>
        </BootstrapDialog>
    );
}
